import { z } from "zod";

export const userSchema = z.object({
  name: z.string().min(1, "User name is required"),
  email: z.string().min(1, "Email is required").email("Invalid email format"),
  roles: z.number().min(1, "Role is required")
});

export type UserFormData = z.infer<typeof userSchema>;
